import React from 'react';
import { Tag } from 'antd';
import { inboundManifestation } from 'constants/inboundInvoices';

const InboundInvoiceManifestationTag = ({ status }) => {
  if (!status || status === 'none') {
    return <span className="gx-text-grey">—</span>;
  }

  const config = inboundManifestation[status];

  return <Tag color={config?.color || 'default'}>{config?.label || status}</Tag>;
};

export default InboundInvoiceManifestationTag;
